"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganization = void 0;
var shared_1 = require("@clerk/shared");
Object.defineProperty(exports, "useOrganization", { enumerable: true, get: function () { return shared_1.useOrganization; } });
